import React from 'react';
import PropTypes from 'prop-types';
import {withFormsy, propTypes} from "formsy-react";
import {FormGroup, Label, Input, FormFeedback} from 'reactstrap';
import {FormattedMessage} from "react-intl";

class SelectFormGroup extends React.Component {
    static propTypes = {
        label: PropTypes.element,
        characterLimit: PropTypes.number,
        values: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        })).isRequired,
        ...propTypes
    };

    constructor(props) {
        super(props);

        this.changeValue = this.changeValue.bind(this);
    }

    changeValue(event) {
        const value = event.target.value;
        this.props.setValue(value);
    }

    render() {
        const {name, id, label, values, characterLimit, getValue, showError, isPristine, showRequired, getErrorMessage} = this.props;
        const valid = isPristine() ? null : (!showError() && !showRequired());

        const value = getValue() ? getValue() : '';

        return (
            <FormGroup>
                {typeof label !== "undefined" &&
                <Label for={id}>
                    {label}
                </Label>
                }

                {typeof characterLimit !== "undefined" &&
                    <span className="form-limit text-muted">
                        <FormattedMessage id="form.input.limit" defaultMessage="{left, plural, one {# character} other {# characters}} left" values={{left: characterLimit - getValue().length}} />
                    </span>
                }

                <Input valid={valid} invalid={!isPristine() && !valid} name={name} id={id} type="select" value={value} onChange={this.changeValue}>
                    {values.map((item, idx) => (
                        <option value={item.value} key={idx}>{item.name}</option>
                    ))}
                </Input>

                {showError &&
                <FormFeedback>
                    {getErrorMessage()}
                </FormFeedback>
                }
            </FormGroup>
        )
    }
}

export default withFormsy(SelectFormGroup);


// WEBPACK FOOTER //
// ./src/components/Form/SelectFormGroup.jsx